import Vue from 'vue'

const Products = {
  namespaced: true,

  state: {
    product: {},
    total: 0,
    products: [],
    productTitle: null
  },

  mutations: {
    setProducts(state, data) {
      data = data || {}
      state.products = data.products || []
      state.total = data.total || 0
    },
    setProduct(state, product) {
      state.product = product || {}
      state.productTitle = state.product.title
    }
  },

  actions: {
    async getAll({ commit }, options = {}) {
      const { page, sortBy, sortDesc, itemsPerPage, showDisabled, search, scope } = options
      const params = { page, itemsPerPage, showDisabled, search, ...scope }
      if (sortBy && sortBy.length) {
        params.sortBy = sortBy
          .map((sort, index) => `${sort}:${sortDesc[index] ? 'desc' : 'asc'}`)
          .join(';')
      }
      const response = await Vue.axios.get('/products', { params })
      const { data, total } = response.data
      commit('setProducts', { products: data, total })
    },
    async get({ commit }, id) {
      let product = { image: null }
      if (id) {
        const response = await Vue.axios.get(`/product/${id}`)
        product = response.data.data
      }
      commit('setProduct', product)
    },
    async createOrUpdate({ commit, state }) {
      let response
      if (state.product.id) {
        response = await Vue.axios.put(`/product/${state.product.id}`, state.product)
      } else {
        response = await Vue.axios.post('/product', state.product)
      }
      commit('setProduct', { ...state.product, ...response.data.data })
    }
  }
}

export default Products
